import "../scss/index.scss";

// Import Best Sabel Modules
import MegaNav from "./modules/Meganav";
import MobileSubNav from "./modules/MobileSubNav";
import MobileScroll from "./modules/MobileNavScroll";
import PopUp from "./modules/popup";
import Filter from "./modules/FilterPost";
import LoadMore from "./modules/LoadMore";
import Copyclip from "./modules/Clipboardcopy";

// Instantiate a new object using modules/classes
const copy = new Copyclip();
const mobilescroll = new MobileScroll();
const popup = new PopUp();
const filter = new Filter();
const loadmore = new LoadMore();

// header sticky home force 1 second load delay
document.addEventListener("DOMContentLoaded", function () {
  // Überprüfen, ob das Element existiert
  const homeElement = document.querySelector(".header.sticky.home .container");
  if (homeElement) {
    // Change opacity to 1 with a 1-second transition
    homeElement.style.transition = "opacity 4s ease 1s";
    homeElement.style.opacity = 1;
  }
});

///Helper JS for Desktop & Mobile Nav
var w = document.documentElement.clientWidth || window.innerWidth;
if (w >= 1250) {
  const meganav = new MegaNav();
} else {
  const mobilesubnav = new MobileSubNav();
}
// 3rd party packages
// Swiper Slider Import Pon
// import Swiper JS
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
// import Swiper
import "swiper/css";
import "swiper/css/navigation";

new Swiper(".quoteswiper", {
  // configure Swiper to use modules
  modules: [Navigation],
  // Optional parameters
  direction: "horizontal",
  loop: true,
  slideToClickedSlide: true,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

new Swiper(".imageslider-swiper", {
  // required Navigation for Navigation arrow
  modules: [Navigation],
  centeredSlides: true,
  spaceBetween: 20,
  keyboard: {
    enabled: true,
  },
  // Optional parameters
  direction: "horizontal",
  loop: true,
  slideToClickedSlide: true,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  initialSlide: 1,
  breakpoints: {
    1200: {
      slidesPerView: "auto",
    },
    800: {
      slidesPerView: "2",
    },
    400: {
      slidesPerView: "1.8",
    },
  },
  // under 400
  slidesPerView: "1.5",
});
new Swiper(".hero-swiper", {
  // required Navigation for Navigation arrow
  modules: [Navigation],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  // required Navigation for Navigation arrow
  slidesPerView: "auto",
  centeredSlides: true,
  keyboard: {
    enabled: true,
  },
});

//https://simplelightbox.com/ https://dbrekalo.github.io/simpleLightbox/
import SimpleLightbox from "../node_modules/simple-lightbox/dist/simpleLightbox";
import "../node_modules/simple-lightbox/dist/simpleLightbox.css"; // style

//Two example function from resp as reference
// Lightbox for Galerie Block
new SimpleLightbox({
  elements: ".block-galerie-designschule a",
});

// Lightbox for Image Slider
var gallery_slider_module = jQuery(".imageslider");

// Iterate over each gallery slider
gallery_slider_module.each(function () {
  // Find the anchor elements in the current gallery slider
  var anchors = jQuery(this).find("a");

  // Initialize a separate lightbox instance for the current gallery slider
  var slider = anchors.simpleLightbox();
});

// for single simplelightbox
jQuery(".splightbox").simpleLightbox();
